import screens from '../common/screens';
import { useMapElement } from '../contextProviders/MapElementProvider';
import NavigationOverrideDetails from '../common/navigationOverrides/NavigationOverrideDetails';
import OperatorConfiguration from './OperatorConfiguration';
import OperationDetails from './OperationDetails';
import MacroDetails from './MacroDetails';
import OutcomeDetails from '../common/OutcomeDetails';

const OperatorRouter = () => {
    const {
        currentScreen,
        mapElement,
        selectedOutcomeIndex,
        onSwitchScreen,
        setSelectedOutcomeIndex,
    } = useMapElement();

    switch (currentScreen) {
        case screens.operator:
            return <OperatorConfiguration />;

        case screens.operationDetails:
            return <OperationDetails />;

        case screens.macroDetails:
            return <MacroDetails />;

        case screens.navigationOverrides:
            return <NavigationOverrideDetails />;

        case screens.outcome: {
            const selectedOutcome = mapElement.outcomes?.[selectedOutcomeIndex ?? 0] ?? null;

            return (
                <OutcomeDetails
                    outcome={selectedOutcome}
                    onSave={() => onSwitchScreen(screens.operator)}
                    onCancel={() => {
                        onSwitchScreen(screens.operator);
                        setSelectedOutcomeIndex(null);
                    }}
                />
            );
        }

        default:
            return null;
    }
};

export default OperatorRouter;
